type TokenizerType = 'text' | 'substitution'

export interface Token {
  type: TokenizerType
  content: string
}

function tokenizer(str: string, matchRex = /\{\s*([^\}]+?)\s*\}/g): Token[] {
  let currentIndex = 0
  let match
  const result = []

  while ((match = matchRex.exec(str))) {
    if (match.index > currentIndex) {
      result.push(makeToken('text', str.slice(currentIndex, match.index)))
    }

    result.push(makeToken('substitution', match[1]?.trim() ?? ''))

    currentIndex = matchRex.lastIndex
  }

  if (currentIndex < str.length) {
    result.push(makeToken('text', str.slice(currentIndex)))
  }

  return result
}

function makeToken(type: TokenizerType, content: string): Token {
  return {
    type,
    content,
  }
}

export default tokenizer
